import { computed, ComputedRef, Ref, ref } from "vue";
import { DynamicStep } from "@/types/DynamicStep";

/**
 * Composable for managing stepped navigation through a dynamic list of steps.
 *
 * @param steps - A computed array of steps that can change based on application state
 * @returns An object containing the current step, counter, and navigation methods
 */
export function useStepper(steps: ComputedRef<DynamicStep[]>) {
  const counter: Ref<number> = ref(1);

  const current = computed<DynamicStep>(() => {
    return steps.value[counter.value - 1];
  });

  function next() {
    counter.value = Math.min(counter.value + 1, steps.value.length);
  }

  function prev() {
    counter.value = Math.max(counter.value - 1, 1);
  }

  function reset() {
    counter.value = 1;
  }

  return {
    counter,
    current,
    next,
    prev,
    reset,
  };
}
